module.exports = __webpack_public_path__ + "static/media/poster_bharat.b23383b3.pdf";